import React from "react";
import surya from "../../media3/featurePage/surya.png";

function FeatureLevelUp() {
    const handleExploreClick = () => {
    const upcomingSkinsSection = document.getElementById('upcoming-skins');
    if (upcomingSkinsSection) {
      upcomingSkinsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <section className="feature-levelup-section">
      <div className="levelup-card">
        <div className="levelup-content">
          <h1>Level Up Your Inventory <br /> Today</h1>
          <p>
            Unlock premium skins and flex your style in every <br /> match. Instant access,
            zero waiting — your next <br /> favorite skin is one click away.
          </p>
         <button className="levelup-explore-btn" onClick={handleExploreClick}>Explore Skins Now</button>
        </div>

        <div className="levelup-image-wrapper">
          <img src={surya} alt="Character" className="levelup-img" />
        </div>
      </div>
    </section>
  );
}

export default FeatureLevelUp;
